















































































import InformationCard from "@/features/information/components/information-card.vue";
import { Famille } from "@/models/Famille";
import { Individu } from "@/models/Individu";
import { utils } from "@/util";
import Vue from "vue";

export default Vue.extend({
  props: {
    individu: {
      type: Individu || undefined
    },
    familleIndividu:{
      type:Famille || undefined
    }
  },
  components: {
    InformationCard
  },
  methods: {
  },
  computed:{
    getNomCompletIndividu(){
      return `${this.individu.getNom()} ${this.individu.getPrenom()}`;
    },
    customStyleTitreFicheInd() {
      return {
        color: "#1f827a",
        textAlign: "left",
        paddingLeft: "120px" // 20px padding + 100px photo width
      };
    },
  },
  filters: {
    inverseDate: (datenaissance: string) => {
      if (!datenaissance) return "";
      let d = utils.getDateFromString(datenaissance, "YYYY-MM-DD");
      return d.format("DD-MM-YYYY");
    }
  }
});
